import React from 'react';

import { LoadableLazy } from '@confluence/loadable';

import { useIsStorageEnforcementEligible } from '../../hooks/useIsStorageEnforcementEligible.ts';

const GracePeriodModalLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GracePeriodModalLoadable" */ './GracePeriodModal.tsx'
			)
		).GracePeriodModalErrorBoundary,
});

export const GracePeriodModal = () => {
	const isEligibleUser = useIsStorageEnforcementEligible();
	return isEligibleUser ? <GracePeriodModalLoadable /> : null;
};
